export default __webpack_public_path__ + "static/media/heartfulness.aa91d7da.gif";